import React, { useEffect } from 'react';
import Icon from './Icon';
import Heading from './Heading';
import errorIcon from '../assets/svg/somethingWentWrongSign.svg';
import successIcon from '../assets/icons/svg/colored-icons/ic-colored-success.svg';
import exitIcon from '../assets/svg/x-icon.svg';

interface IProps {
    content: string;
    onClose: () => void;
    isError: boolean;
    autoDismiss: boolean;
}

export const TopAlertBar = ({
  content, onClose, isError, autoDismiss,
}: IProps) => {
  useEffect(() => {
    if (autoDismiss) {
      setTimeout(() => {
        onClose();
      }, 3500);
    }
  }, []);
  return (

    <div className='fixed top-[0px] left-[50%] translate-x-[-50%] w-[50%] bg-bw03 flex items-center justify-center px-[20px] py-[10px] z-[9999] rounded-br-[8px] rounded-bl-[8px]'>
      <Icon src={isError ? errorIcon : successIcon} className='mr-[8px]' />
      <Heading title={content} className='font-metricMedium text-bw08 text-sm' />
      <Icon onClick={() => onClose()} src={exitIcon} className='absolute right-[20px] cursor-pointer' />
    </div>
  );
};
